var body = document.body

if(document.querySelector('.dark-mode-wrapper input')){
    document.querySelector('.dark-mode-wrapper input').addEventListener('change', (e)=> {
        var darkModeValue = e.target.value
        if(darkModeValue == 'light-mode'){
            body.classList.add('dark-mode')
            sessionStorage.setItem('themeMode', 'dark-mode')   
            e.target.value = 'dark-mode'
        }else{
            body.classList.remove('dark-mode')
            sessionStorage.setItem('themeMode', 'light-mode')   
            e.target.value = 'light-mode'
        }
    })
}

if(document.querySelector('.dark-mode-wrapper input')){
    if(sessionStorage.getItem('themeMode') != null && sessionStorage.getItem('themeMode') != ""){
        if(sessionStorage.getItem('themeMode') == 'dark-mode'){
            body.classList.add('dark-mode')
            document.querySelector('.dark-mode-wrapper input').setAttribute('checked', true)
            document.querySelector('.dark-mode-wrapper input').value = 'dark-mode'
        }else{
            document.querySelector('.dark-mode-wrapper input').value = 'light-mode'
        }
    }else{
        document.querySelector('.dark-mode-wrapper input').value = 'light-mode'
    }
}


function cartPlusSizeSwatches(){
    // Cart plus button and size swatches on product grids
    document.querySelectorAll('.quick-add-cart-wrapper').forEach(item => {
        item.addEventListener('click', () => {
             console.log('click 2')
            if (!item.closest('.card__content').querySelector('.quick-cart-add').hasAttribute('default-varaint-only')) {
                item.closest('.card__content').querySelector('.quick-cart-add').classList.add('active');
            } else {
                item.closest('.card__content').querySelector('.quick-cart-add li').click();
            }
            body.classList.add('dropdown-shadow')
            body.classList.add('size-swatch-active')
            if(window.innerWidth < 749){
            body.classList.add('hidescroll')
            }
        })
    })
}
cartPlusSizeSwatches()

function soldOutPopup(){
    // Soldout Popup open/close on product grids
    document.querySelectorAll('.quick-cart-add ul li.sold_out').forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault()
            var variantUrl = item.getAttribute('data-url')
            var finalLink = `${variantUrl}` 
            document.querySelector('#soldout-popup .notify-me').setAttribute('href', finalLink)
            body.classList.add('soldout-popup-active')
            body.classList.add('dropdown-shadow')
            body.style.overflow = 'hidden'
            item.closest('.quick-cart-add').classList.remove('active')
            item.closest('.card-wrapper').style.display = 'block'
        })
    })
    document.querySelectorAll('#soldout-popup .continue-shopping').forEach(a => {
        a.addEventListener('click', (e)=> {
            e.preventDefault()
            body.classList.remove('soldout-popup-active')
            body.classList.remove('dropdown-shadow')
            body.style.overflow = 'inherit'
        })
    })
}
soldOutPopup()


// Selecting relevant menu on the basis of active category
var menuTop = document.querySelectorAll('.special-menu-item')
menuTop.forEach(item => {
    if (getCookie('activeCategory') != null && getCookie('activeCategory') != 'null' && getCookie('activeCategory') != ""){
        item.classList.remove('active')
        if (getCookie('activeCategory') == "men"){
            if (item.getAttribute('data-category') == 'category-men'){
                item.classList.add('active')
            }
        }
        else if(getCookie('activeCategory') == "women"){
            if (item.getAttribute('data-category') == 'category-women'){
                item.classList.add('active')
            }
        }
        else{
            if (item.getAttribute('data-category') == 'category-juniors'){
                item.classList.add('active')
            }
        }
    }
})

// Menu Drawer header categories

var specialMenuItems = document.querySelectorAll('.special-menu-item')
specialMenuItems.forEach(item=>{
    item.addEventListener('click',(e)=>{
        specialMenuItems.forEach(e=>{
            e.classList.remove('active')
        })
      console.log('hi------>', specialMenuItems )
        item.classList.add('active')
        var menuItem = item.getAttribute('data-menu')
        var mainCategory = menuItem.split('special-menu-')
        setCookie('activeCategory', mainCategory[1], 365)
        var menuListItems =  document.querySelectorAll('.special-menu-drawer__submenu')
        menuListItems.forEach(itm=>{
            itm.classList.add('visually-hidden')
        })
        document.querySelector(`.${menuItem}`).classList.remove('visually-hidden')

    })
})

var colorItems = document.querySelectorAll('.option_color')
// Loop over them and change colors 
colorItems.forEach(item=>{
    var itemColor =  item.getAttribute('data-color')
    item.style.color = itemColor
})

    // Header and toolbar sticky on collection page
    var lastScroll = 0
    window.addEventListener("scroll", ()=> {
        // console.log(window.scrollY , 'scrolling');
        // if(window.scrollY > 200){
        // if(window.scrollY > 45){
        //     body.classList.add('sticky')
        // }else{
        //     body.classList.remove('sticky')
        // }  
        var scrollThreshold;
        if (window.innerWidth <= 767) {
            scrollThreshold = 5; // Mobile
        } else {
            scrollThreshold = 45; // Desktop
        }

        if (window.scrollY > scrollThreshold) {
            body.classList.add('sticky');
        } else {
            body.classList.remove('sticky');
        }

        const currentScroll = window.pageYOffset
        if (currentScroll <= 0) {
            body.classList.remove('scrollUp')
            return
        }
        if (currentScroll > lastScroll && !body.classList.contains('scrollDown')) {
            body.classList.remove('scrollUp')
            body.classList.add('scrollDown')
        } 
        else if (currentScroll < lastScroll && body.classList.contains('scrollDown')) {
            body.classList.remove('scrollDown')
            body.classList.add('scrollUp')
        }
        lastScroll = currentScroll
    })

// footer menu dropdown in main menu drawer on mobile
var footHeader = document.querySelector('.foot-menu-header')
footHeader.addEventListener('click', ()=> {
    footHeader.classList.toggle('active')
    footHeader.closest('.menu-footer').querySelector('.menu-drawer__menu').classList.toggle('hidden')
})


function variantImageURLChanger(){
    // variant image changer and relevant url on product grid
    var color = document.querySelectorAll('.item-image-wrapper:not(.single-swatch)')
  console.log(color);
    color.forEach(item => {
        item.addEventListener('click', ()=> {
          /* Start 'Dev-M571' Show variant price and compare price */
          var variantPrice = parseInt(item.getAttribute('data-variant-price'));
          var variantComparePrice = parseInt(item.getAttribute('data-variant-compare-price'));
          var price = item.closest('.card-wrapper').querySelector('.price__regular .price-item--regular .money');

          var comparePrice = item.closest('.card-wrapper').querySelector('.price-item--sale .money');
          var badgePercentage = item.closest('.card-wrapper').querySelector('.price-item--sale .sale-badge');
          var checkOnSale = item.closest('.card-wrapper').querySelector('.price');

          if (variantPrice === variantComparePrice) {
            checkOnSale.classList.remove('price--on-sale');

          item.closest('.card-wrapper').querySelector('.price__regular .price-item--regular .money').innerHTML = `${Shopify.currency.active} ${variantPrice.toLocaleString()}`;
          } else {
            if (!checkOnSale.classList.contains('price--on-sale')) {
              checkOnSale.classList.add('price--on-sale');
              var badgePercentage = Math.trunc((((variantComparePrice - variantPrice) / variantComparePrice) * 100));
              item.closest('.card-wrapper').querySelector('.price-item--sale .sale-badge').innerHTML = `-${badgePercentage}%`;
              item.closest('.card-wrapper').querySelector('.price__sale .price-item--regular .money').innerHTML = `${Shopify.currency.active} ${variantComparePrice}`;
              item.closest('.card-wrapper').querySelector('.price__sale .price-item--sale .money').innerHTML = `${Shopify.currency.active} ${variantPrice}`;
            }
          }
          /* End 'Dev-M571' Show variant price and compare price */
            var variantUrl = item.getAttribute('url')
            var variantColor = item.getAttribute('data-value')
          console.log(variantColor);
            var variantImageId = item.getAttribute('data-img-id') 
            var variantImg = item.getAttribute('data-img')
            var otherColors = item.closest('.item-swatch').querySelectorAll('.item-image-wrapper')
            otherColors.forEach(v => {
                v.classList.remove('active')
            })
            item.classList.add('active')
            item.closest('.card-wrapper').querySelector('.image-first').setAttribute('srcset', variantImg)
            item.closest('.card-wrapper').querySelector('.image-first').setAttribute('src', variantImg)
            item.closest('.card-wrapper').querySelector('.image-first').setAttribute('src', variantImg)
            var sizeSwatch = item.closest('.card-wrapper').querySelectorAll('.quick-cart-add ul li')
            sizeSwatch.forEach(a => {
                a.classList.add('hide-variant')
                if (a.getAttribute('data-show') == variantColor){
                    a.classList.remove('hide-variant')
                }
            })

            // for second image
            var filter = `.id-${variantImageId}`
            var secondImage = item.closest('.item-swatch').querySelector(filter).nextElementSibling.getAttribute('data-image')
            item.closest('.card-wrapper').querySelector('.image-second').setAttribute('srcset', secondImage)
            item.closest('.card-wrapper').querySelector('.image-second').setAttribute('src', secondImage)
            item.closest('.card-wrapper').querySelector('.image-second').setAttribute('src', secondImage)

            // for setting active variant url
            item.closest('.card-wrapper').querySelectorAll('.product-link-main').forEach(b => {
                b.setAttribute('href', variantUrl)
            })
        })
    })

    // Set relevant/active url of product variant on pageload
    var activeColor = document.querySelectorAll('.item-image-wrapper.active:not(.single-swatch)')
    activeColor.forEach(a => {
        var activeUrl = a.getAttribute('url')
        a.closest('.card-wrapper').querySelectorAll('.product-link-main').forEach(b => {
            b.setAttribute('href', activeUrl)
        })
    })
}
variantImageURLChanger()

document.querySelectorAll('.close-cart').forEach(a => {
    a.addEventListener('click', (e)=> {
        e.preventDefault()
        body.classList.remove('cart-popup-active')
        body.classList.remove('hidescroll')
        body.classList.remove('dropdown-shadow')
    })
})


// Dropdown Shadow close button
document.querySelector('#dropdown-shadow').addEventListener('click', (e)=> {
    e.preventDefault()
    if(document.querySelector('.product-form__input-mobile.option-size')){
        document.querySelector('.product-form__input-mobile.option-size').classList.remove('active')
    }
    if(body.classList.contains('soldout-popup-active')){
        body.classList.remove('soldout-popup-active')
    }
    if(body.classList.contains('cart-popup-active')){
        body.classList.remove('cart-popup-active')
    }
    document.querySelectorAll('.quick-add-cart-wrapper').forEach(item => {
        if(item){
            item.closest('.card__content').querySelector('.quick-cart-add').classList.remove('active')
            body.classList.remove('size-swatch-active')
            if(window.innerWidth < 749){
            body.classList.remove('hidescroll')
            }
        }
    })
    if(document.querySelector('.template-search__search')){
        body.classList.remove('predictive-search-active')
    }
    if(document.querySelector('.campaign-popup')){
        body.classList.remove('campaign-popup-show')
    }
    body.classList.remove('dropdown-shadow')
    body.style.overflow = 'inherit'
})

// function addToCart(){
//     // Add to cart functionality on product grids
//     var btn = document.querySelectorAll('.quick-cart-add ul li:not(.sold_out)')
//     btn.forEach(item => {
//       item.addEventListener('click', ()=> {
//         console.log('click !!!')
//         var variantId = item.getAttribute('data-id')
//         item.closest('.card-wrapper').classList.add('size-selected')
//         item.closest('.card-wrapper').setAttribute('data-variant-id', variantId)
//         if(!item.closest('.complete-look-bundle-section')){
//             var formData = {
//             'items': [{
//               'id': variantId,
//               'quantity': 1
//               }]
//             }
//             console.log('click', formData)
//             fetch('/cart/add.js', {
//               method: 'POST',
//               headers: {
//                 'Content-Type': 'application/json'
//               },
//               body: JSON.stringify(formData)
//             })
//             .then(response => {
//               return response.json()
//             })
//             .then((data)=>{
//               if (data.status === 422){
//                 body.classList.add('cart-error-active')
//                 document.querySelector('#cart-error-popup').innerText = data.description
//                 setTimeout(()=> {
//                     body.classList.remove('cart-error-active')
//                 },3000)
//               }
//               else{
//                 cartPopupUpdate()
//                 setTimeout(()=> {
//                     body.classList.add('cart-popup-active')
//                     body.classList.add('dropdown-shadow') 
//                 },500)
//               }
//             })
//             .catch((error) => {
//                 body.classList.add('cart-error-active')
//                 document.querySelector('#cart-error-popup').innerText = 'An Error Occured. Please try again later'
//                 setTimeout(()=> {
//                     body.classList.remove('cart-error-active')
//                 },3000)
//             })
//             .finally(() => {
//             })
//         }
//         setTimeout(()=>{
//             item.closest('.quick-cart-add').classList.remove('active')
//             item.closest('.card-wrapper').style.display = 'block'
//             body.classList.remove('dropdown-shadow')
//             if(window.innerWidth < 749){
//             body.classList.remove('hidescroll')
//             }
//         },200)
//       },{ once: true })
//     })
// }
function addToCart() {
  // Select all buttons
  var btns = document.querySelectorAll('.quick-cart-add ul li:not(.sold_out)');
  
  btns.forEach(item => {
    // Skip if listener already added
    if (item.dataset.bound === "true") return;
    item.dataset.bound = "true";

    item.addEventListener('click', () => {
      console.log('click !!!');
      var variantId = item.getAttribute('data-id');
      item.closest('.card-wrapper').classList.add('size-selected');
      item.closest('.card-wrapper').setAttribute('data-variant-id', variantId);

      if (!item.closest('.complete-look-bundle-section')) {
        var formData = {
          items: [{
            id: variantId,
            quantity: 1
          }]
        };

        console.log('click', formData);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === 422) {
            body.classList.add('cart-error-active');
            document.querySelector('#cart-error-popup').innerText = data.description;
            setTimeout(() => {
              body.classList.remove('cart-error-active');
            }, 3000);
          } else {
            cartPopupUpdate();
            setTimeout(() => {
              body.classList.add('cart-popup-active');
              body.classList.add('dropdown-shadow');
            }, 500);
          }
        })
        .catch(() => {
          body.classList.add('cart-error-active');
          document.querySelector('#cart-error-popup').innerText = 'An Error Occured. Please try again later';
          setTimeout(() => {
            body.classList.remove('cart-error-active');
          }, 3000);
        });
      }

      setTimeout(() => {
        item.closest('.quick-cart-add').classList.remove('active');
        item.closest('.card-wrapper').style.display = 'block';
        body.classList.remove('dropdown-shadow');
        if (window.innerWidth < 749) {
          body.classList.remove('hidescroll');
        }
      }, 200);
    });
  });
}

addToCart()

// Complete look bundle functionality
document.querySelectorAll('.clb-button').forEach(item => {
    var sizeSelected = false
    var variantids = []
    item.addEventListener('click', (e)=> {
        item.closest('.clb-main-wrapper').querySelectorAll('.card-wrapper').forEach(card => {
            if(card.classList.contains('size-selected')){
                sizeSelected = true
                card.classList.remove('error-size-show')
            }else{
                sizeSelected = false
                card.classList.add('error-size-show')
            }
        })
        if(sizeSelected){
            item.closest('.clb-main-wrapper').querySelectorAll('.card-wrapper').forEach(c => {
                var varId = c.getAttribute('data-variant-id')
                variantids.push(
                    {
                        'id': varId,
                        'quantity': 1
                    }
                )
            })
            var formData = {
                'items': variantids
            }
            console.log('formData',formData)
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json()
            })
            .then((data)=>{
                if (data.status === 422){
                body.classList.add('cart-error-active')
                document.querySelector('#cart-error-popup').innerText = data.description
                setTimeout(()=> {
                    body.classList.remove('cart-error-active')
                },3000)
                }
                else{
                cartPopupUpdate()
                setTimeout(()=> {
                    body.classList.add('cart-popup-active')
                    body.classList.add('dropdown-shadow')
                },500)
                }
            })
            .catch((error) => {
                body.classList.add('cart-error-active')
                document.querySelector('#cart-error-popup').innerText = 'An Error Occured. Please try again later'
                setTimeout(()=> {
                    body.classList.remove('cart-error-active')
                },3000)
            })
            .finally(() => {
            })
        }else{
            document.querySelectorAll('.error-size-show').forEach(a => {
                a.querySelector('.select-size-error').style.display = 'block'
                setTimeout(()=> {
                    a.querySelector('.select-size-error').style.display = 'none'
                },2000)
            })
            item.closest('.clb-main-wrapper').querySelector('.all-size-error').style.display = 'block'
            setTimeout(()=> {
                item.closest('.clb-main-wrapper').querySelector('.all-size-error').style.display = 'none'
            },2000)
        }
    })
})

function removeCartItem(){
    // Remove from cart
    var btn = document.querySelectorAll('.btn-remove')
    btn.forEach(item => {
      item.addEventListener('click', (e)=> {
        e.preventDefault()
        var lineId = item.closest('.item').getAttribute('data-line')
        var formData = {
            'line': lineId,
            'quantity': 0
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json()
        })
        .then((data)=>{
          if (data.status === 422){
          }
          else{
            cartPopupUpdate()
          }
        })
        .catch((error) => {
            body.classList.add('cart-error-active')
            document.querySelector('#cart-error-popup').innerText = 'An Error Occured. Please try again later'
            setTimeout(()=> {
                body.classList.remove('cart-error-active')
            },3000)
        })
      })
    })
}
removeCartItem()

function cartPopupUpdate(){
    // for updating cart popup
    fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
    })
    .then(response => {
        return response.json()
    })
    .then((cart)=>{        
        var lineItems = []
        document.querySelector('.mini-products-list').innerHTML = ''
        var cartCounter = cart.item_count
        document.querySelectorAll('.cart-counter').forEach(counters=>{
           counters.innerText = cartCounter
        })
        var totalPrice = priceFormatting(cart.total_price / 100);
        const activeCollection = (cart.items[0].vendor).toLowerCase();
        if (document.querySelector('.extra-upsell-products.active')) {
            document.querySelector('.extra-upsell-products.active').classList.remove('active');
            if (activeCollection.includes('kids') || activeCollection.includes('girls') || activeCollection.includes('boys') || activeCollection.includes('girl') || activeCollection.includes('boy')) {
                document.querySelector(`.extra-upsell-products[data-collection="kids"]`).classList.add('active');
            } else {
                document.querySelector(`.extra-upsell-products[data-collection="${activeCollection}"]`).classList.add('active');
            }
        }

        cart.items.forEach((item, i) => {
            var itemPrice = priceFormatting(item.price / 100)
            var lineItemDetails = `<li class="item" data-id="${item.id}" data-line="${i+1}">
                <a href="${item.url}" class="product-image">
                <img loading="lazy" src="${item.image}" alt="${item.title}">
                </a>
                <div class="product-details">
                <a href="javascript:void(0)" title="Remove" class="btn-remove">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                        <path d="M1 4.17647H17M6 1H12M7 14.7647V8.41177M11 14.7647V8.41177M12.5 19H5.5C4.39543 19 3.5 18.0519 3.5 16.8824L3.0434 5.27937C3.01973 4.67783 3.47392 4.17647 4.04253 4.17647H13.9575C14.5261 4.17647 14.9803 4.67783 14.9566 5.27937L14.5 16.8824C14.5 18.0519 13.6046 19 12.5 19Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </a>
                <a class="product-name" href="${item.url}">${item.product_title}</a>
                <div class="option">
                <small>${item.variant_title}</small>
                </div>
                <div class="cart-collateral">
                    <div class="cart-quantity">${item.quantity}X</div>
                    <span class="price">
                    <span class="money">PKR ${itemPrice}</span>
                    </span>
                </div>
                </div>
            </li>`
            lineItems.push(lineItemDetails) 
        })
        document.querySelector('.mini-products-list').innerHTML = lineItems.join('')
        document.querySelector('.total .price').innerText = `PKR ${totalPrice}`
        if(cartCounter > 0){
           // document.querySelector('.cart-count-bubble').classList.remove('hidden')
            document.querySelectorAll('.cart-count-bubble').forEach(bubble=>{
                 bubble.classList.remove('hidden')
            })
            document.querySelector('#dropdown-cart .has-items').classList.remove('hidden')
            document.querySelector('#dropdown-cart .no-items').classList.add('hidden')
        }else{
           // document.querySelector('.cart-count-bubble').classList.add('hidden')
           document.querySelectorAll('.cart-count-bubble').forEach(bubble=>{
                 bubble.classList.add('hidden')
            })
            document.querySelector('#dropdown-cart .has-items').classList.add('hidden')
            document.querySelector('#dropdown-cart .no-items').classList.remove('hidden')
        }

    })
    .catch((error) => {
        body.classList.add('cart-error-active')
            document.querySelector('#cart-error-popup').innerText = 'An Error Occured. Please try again later'
            setTimeout(()=> {
                body.classList.remove('cart-error-active')
        },3000)
    })
    .finally(() => {
        removeCartItem()
    })
}

function priceFormatting(price){
    // for formatting price
    var formatPrice = new Intl.NumberFormat('en-PK', { maximumSignificantDigits: 4 }).format(price)
    return formatPrice
}

if(body.classList.contains('collection-template-2024') || body.classList.contains('collection-template-2025')){
function gridtwo(){
    document.querySelector('.new-product-grid').classList.add('grid-2-new')
    document.querySelector('.new-product-grid').classList.remove('grid-4-new')
    document.querySelector('.new-product-grid').classList.remove('grid-6-new')
    document.querySelector('.grid-6-new').classList.remove('active')
    document.querySelector('.grid-4-new').classList.remove('active')
    document.querySelector('.grid-2-new').classList.add('active')
}

function gridfour(){
    document.querySelector('.new-product-grid').classList.add('grid-4-new')
    document.querySelector('.new-product-grid').classList.remove('grid-6-new')
    document.querySelector('.new-product-grid').classList.remove('grid-2-new') 
    document.querySelector('.grid-6-new').classList.remove('active')
    document.querySelector('.grid-2-new').classList.remove('active')
    document.querySelector('.grid-4-new').classList.add('active')
}
function gridsix(){
    document.querySelector('.new-product-grid').classList.remove('grid-4-new')
    document.querySelector('.new-product-grid').classList.remove('grid-2-new')
    document.querySelector('.new-product-grid').classList.add('grid-6-new')
    document.querySelector('.grid-4-new').classList.remove('active')
    document.querySelector('.grid-2-new').classList.remove('active')
    document.querySelector('.grid-6-new').classList.add('active')
}


function changesrc(){
    document.querySelectorAll(".grid-item-list .swiper-wrapper").forEach(allproduct=>{
        var varimg = allproduct.getAttribute("data-var-img")
        if(varimg){
            var firstSwiperSlide = allproduct.querySelector(".swiper-slide:first-child img");
            if(firstSwiperSlide){
                firstSwiperSlide.setAttribute('srcset', varimg);
            }
            
           
        }
       
    })
}
function oldsrc(){
    document.querySelectorAll(".grid-item-list .swiper-wrapper").forEach(allproductold=>{
        var firstimg = allproductold.getAttribute("first-img")
        if(firstimg){
            var firstSwiperSlideold = allproductold.querySelector(".swiper-slide:first-child img");
            if(firstSwiperSlideold){
                firstSwiperSlideold.setAttribute('srcset', firstimg);
            }
           
        }
        
    })
}

function hidecontent(){
    document.querySelectorAll(".card__content").forEach(cardcontent=>{
        cardcontent.classList.add("hidecontent")
    })
    document.querySelectorAll(".sale-percenatge-badge").forEach(salebadge=>{
        salebadge.classList.add("hidecontent")
    })
    document.querySelectorAll(".grid-item-list").forEach(cardslide => {
        var slides = cardslide.querySelectorAll(".swiper-slide:not(:first-child)")
        slides.forEach(allslides=>{
            allslides.classList.add("hidecontent")
        })
    });
}
function showcontent(){
    document.querySelectorAll(".card__content").forEach(cardcontent1=>{
        cardcontent1.classList.remove("hidecontent")
    })
    document.querySelectorAll(".sale-percenatge-badge").forEach(salebadge=>{
        salebadge.classList.remove("hidecontent")
    })
    document.querySelectorAll(".grid-item-list").forEach(cardslide => {
        var slides = cardslide.querySelectorAll(".swiper-slide:not(:first-child)")
        slides.forEach(allslides=>{
            allslides.classList.remove("hidecontent")
        })
    });
}





document.querySelector('.grid-2-new').addEventListener('click', ()=>{
    gridtwo()
    oldsrc()
    showcontent()
})
document.querySelector('.grid-4-new').addEventListener('click', ()=>{
    gridfour()
    oldsrc()
    showcontent()
}) 
document.querySelector('.grid-6-new').addEventListener('click', ()=>{
    gridsix()
    hidecontent()
    changesrc()
})

document.querySelectorAll(".grid-item-list").forEach((allgrid,allgridind)=>{
    if(allgridind == 0){
        var slides = allgrid.querySelector(".swiper-wrapper");
        slides.classList.add("animationadd")
            setTimeout(function() {
              slides.classList.remove("animationadd")
              slides.classList.add("animationremove")
            }, 1500);
    }
})


function sizeSwatchwidth(){
    var ulList = document.querySelectorAll('.sizeSwatch');
    
    ulList.forEach(function(ul) {
        var liItems = ul.querySelectorAll('li');
        var lastLi = liItems[liItems.length - 1];

        if (liItems.length % 2 === 0) {
            lastLi.style.width = "50%";
        } else {
            lastLi.style.width = "100%";
            lastLi.style.borderRight = "none";
            
        }
    });
}
sizeSwatchwidth()



 }


// cookie base active categoires of child menu
var activeCategory
// for marketing or campaigns switch category by using this format e-g this link (https://outfitters.com.pk/?category=men) shows men category
if(window.location.href.includes('?category=men')){
    activeCategory = 'men'
    setCookie('activeCategory', activeCategory, 365)
}
else if(window.location.href.includes('?category=women')){
    activeCategory = 'women'
    setCookie('activeCategory', activeCategory, 365)
}
else if(window.location.href.includes('?category=juniors')){
    activeCategory = 'juniors'
    setCookie('activeCategory', activeCategory, 365)
}
// when cookie of active category is available
else if (getCookie('activeCategory') != null && getCookie('activeCategory') != 'null' && getCookie('activeCategory') != ""){
    activeCategory = getCookie('activeCategory')
}
// when active category is selected from them settings
else{
    activeCategory = body.getAttribute('data-activeCategory')
    setCookie('activeCategory', activeCategory, 365)
}

if (getCookie('activeCategory') != null && getCookie('activeCategory') != 'null' && getCookie('activeCategory') != ""){
   if (getCookie('activeCategory') == "men"){
        document.querySelector('.special-menu-women').classList.add('visually-hidden')
        document.querySelector('.special-menu-juniors').classList.add('visually-hidden')
        document.querySelector('.special-menu-men').classList.remove('visually-hidden')
   }
  else if(getCookie('activeCategory') == "women"){
        document.querySelector('.special-menu-women').classList.remove('visually-hidden')
        document.querySelector('.special-menu-juniors').classList.add('visually-hidden')
        document.querySelector('.special-menu-men').classList.add('visually-hidden')
  }
  else{
        document.querySelector('.special-menu-women').classList.add('visually-hidden')
        document.querySelector('.special-menu-juniors').classList.remove('visually-hidden')
        document.querySelector('.special-menu-men').classList.add('visually-hidden')
  }
}









if(body.classList.contains('template-collection') || body.classList.contains('template-search')){

   // Load More AND Load previous functionality on collection page and search page

   var loadmore_btn = document.querySelector(".load-more-cstm-btn")
   var products_on_page = document.querySelector("#product-grid")
   var loadmore_spinner = document.querySelector(".load-more-spinner")
   var no_more = document.querySelector(".no-more-cstm")
   if (no_more){
     no_more.style.display = "none"
   } 
   if(document.querySelector('.loadmore-less')){
        no_more.style.display = "block"
   }
   if(loadmore_spinner){
     loadmore_spinner.style.display = "none"
   }
  

   var loadprev_btn = document.querySelector(".load-prev-cstm-btn")
   var loadprev_spinner = document.querySelector(".load-prev-spinner")
  var next_url = products_on_page.getAttribute('data-next-url')

  function loadMoreProducts(){ 

     if(!next_url){
      no_more.style.display = "block"
     }
    if(next_url){
        fetch(next_url)
        .then((response)=>{
        loadmore_btn.style.display = "none"
        loadmore_spinner.style.display = "inline-block"
        return response.text()
        })
        .then((data)=>{
        var parser = new DOMParser()
        var doc = parser.parseFromString(data, 'text/html')
        var return_html = doc.body
        var main_html = return_html.querySelector('#product-grid')
        const mainGrid = document.querySelector('#product-grid');
     
        var new_url = main_html.getAttribute('data-next-url')
        loadmore_spinner.style.display = "none"
        if(new_url){
            loadmore_spinner.style.display = "inline-block"
            loadmore_btn.style.display = "none"
        }
        next_url = new_url
        setTimeout(()=>{
            mainGrid.insertAdjacentHTML('beforeend', main_html.innerHTML);
 
            loadmore_spinner.style.display = "none"
            if(new_url){
                loadmore_btn.style.display = "block"
            }
            else{
                products_on_page.setAttribute('data-next-url','')
                loadmore_btn.classList.remove('load-more-cstm-btn')
                loadmore_btn= ''
                next_url = ''
                no_more.style.display = "block"
            }
            console.log(next_url)
            cartPlusSizeSwatches()
            soldOutPopup()
            addToCart()
            initializeSwiper()
            sizeSwatchwidth()
            sizeguide()
          if(document.querySelector(".new-product-grid").classList.contains("grid-6-new")){
            hidecontent()
            gridsix()
            changesrc()
        }else if(document.querySelector(".new-product-grid").classList.contains("grid-4-new")) {
            showcontent()
            gridfour()
            oldsrc()
          
        }
        else if(document.querySelector(".new-product-grid").classList.contains("grid-2-new")) {
            showcontent()
            gridtwo()
            oldsrc()
           
        }
        },500) 
        })
        .catch((err)=>{
          console.log(err)
        })
    }
  }

  if(document.querySelectorAll('#load-more-cstm-btn').length > 0){
    document.querySelector('.load-more-cstm-btn').addEventListener('click', ()=>{
      loadMoreProducts()
    })
  }
    var btnClick = new Event('click')
    document.addEventListener('scroll',function() {
    var collectionTplElm = document.querySelector('.collection_top-wrapper')
        var collectionTop = window.innerHeight
        var collectionHeight = collectionTplElm.clientHeight
        var posTop = collectionTop + collectionHeight - window.innerHeight
        if (window.pageYOffset > posTop - 5000 && window.pageYOffset < ( posTop + 10000  )) {
            if(loadmore_btn){	
            if(loadmore_btn.classList.contains('btn-disabled')){
                }
            else{
            loadmore_btn.dispatchEvent(btnClick)
                loadmore_btn.classList.add('btn-disabled')
            setTimeout(function() {
                    if(loadmore_btn){
                    loadmore_btn.classList.remove('btn-disabled')
                        }
            }, 3000)
            }}
        }
      
    })
}





  
